/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".custom-snackbar-container[_ngcontent-%COMP%]{display:flex!important;flex-direction:row!important}.custom-snackbar-container[_ngcontent-%COMP%]   .actions-buttons-wrapper[_ngcontent-%COMP%]{display:flex!important;flex-direction:column!important;justify-content:center!important;align-items:center!important}"];
export { styles as styles };
